define('actions/boards',[
	"jquery",
	"underscore",
	"backbone",
	"dispatcher/AppDispatcher",
	"constants/actiontypes"
], function($, _, Backbone, AppDispatcher, Constants) {
	return Backbone.Model.extend({
		pulling: [],
		init: function(params) {
		},
		addBoard: function(params) {
			AppDispatcher.dispatch({
				actionType: Constants.CREATE_BOARD,
				data: params
			});
		},
		initBoard: function(item) {
			return _.extend(item.data, {
				id: item.data.guid,
				self: item.links.self,
				links: item.links,
				thumbnail_url: item.data.thumbnail_url
			});
		},
		deleteBoard: function(guid) {
			AppDispatcher.dispatch({
				actionType: Constants.DELETE_BOARD,
				data: {
					guid: guid
				}
			})
		},
		create: function(data, success, failure) {
			var self = this;

			var promise = window.api.request("boards").create(data);

			promise.done(function(response) {
				self.addBoard([self.initBoard(response)]);
				window.open("/bunceeboard/"+response.data.guid);

				if(typeof success != "undefined")
					success();
			});

			promise.fail(function(response) {
				if(typeof failure == "function") {
				failure("Failed to create board. Please try again.");
				}
			});
		},
		pull: function(oncomplete) {
			var self = this;
			var boards = [];
			window.api.request("boards").each(function iterator (index, item) {
				boards.push(self.initBoard(item));
			}, function () { 
				self.addBoard(boards);
				if (typeof onComplete === "function") {
					onComplete();
				}
			});
		},
		pullByGuid: function(guid, oncomplete) {
			var self = this;
			if(this.pulling.indexOf(guid) > -1) {
				return;
			}
			this.pulling.push(guid);
			window.api.request("boards", guid).execute().done(function(response) {
				self.pulling.splice(self.pulling.indexOf(guid), 1);
				self.addBoard(self.initBoard(response));
				if(typeof oncomplete === "function") {
					oncomplete();
				}
			});
		},
		delete: function(guid, success, failure) {
			var self = this;
			window.api.request("boards", guid).delete().done(function() {
				if(typeof success != "undefined"){
					success();
				}
				self.deleteBoard(guid);
			})
			.fail(function () {
					failure();
			});
		}
	})
});
